export default __webpack_public_path__ + "static/media/status-live.bca51630.svg";